import { normalizeLoadResult } from "./remote-store";

const EMPTY = [];

function toPromise(result) {
  if (result && typeof result.done === "function" && typeof result.fail === "function")
    return new Promise((resolve, reject) => {
      result
        .done((data, extra) =>
          resolve(extra && typeof extra === "object" ? { ...extra, data } : data)
        )
        .fail(reject);
    });

  return Promise.resolve(result);
}

function storeKey(store) {
  if (!store) return undefined;
  if (typeof store.key === "function") return store.key();

  return store.key;
}

export function resolveSource(dataSource, keyExpr) {
  if (dataSource == null)
    return { kind: "local", key: keyExpr, getItems: () => EMPTY, store: null };

  if (Array.isArray(dataSource))
    return { kind: "local", key: keyExpr, getItems: () => dataSource, store: dataSource };

  if (typeof dataSource === "object" && "store" in dataSource && !dataSource.load)
    return { ...resolveSource(dataSource.store, keyExpr), dataSourceOptions: dataSource };

  if (Array.isArray(dataSource._array))
    return {
      kind: "local",
      key: keyExpr ?? storeKey(dataSource),
      getItems: () => dataSource._array,
      store: dataSource,
    };

  if (typeof dataSource.load === "function")
    return {
      kind: "remote",
      key: keyExpr ?? storeKey(dataSource),
      load: (loadOptions, requestOptions) =>
        toPromise(dataSource.load(loadOptions, requestOptions)).then(normalizeLoadResult),
      store: dataSource,
    };

  return { kind: "local", key: keyExpr, getItems: () => EMPTY, store: dataSource };
}
